/** 配方 ，如果数据改变时有可能需要重置配方
 * s ： 产物(可能多产物,第一个产物必须是配方产品)
 * q ： 需求
 * m ： 生产设备
 * t ： 生产时间(秒)
 * p ： 增产剂模式 undefined：可加速增产 1：仅可加速 -1：禁用
 * mp： 轨道采集器_产物名称 提供一个便捷标识
 * n ： 显示配方数量(如果不提供就是1)
 * rn： 实际使用数量(如果不提供就是n)
 * c ： 目标产物数量(自动计算 s[0].rn)
 * cq： 原料数量(自动计算 sum(q.n) 影响增产剂消耗)
 */
export const formulaInit = factorys => {
  const fn = i => {
    i.n = i.n === undefined ? 1 : i.n;
    i.rn = i.rn === undefined ? i.n : i.rn;
  };
  for (let key in formulaAll) {
    for (let item of formulaAll[key]) {
      item.s.forEach(fn);
      item.q.forEach(fn);
      item.cq = item.q.reduce((a, b) => a + (b.n || 1), 0);
      item.c = item.s[0].rn;
      if (item.q.length == 0) {
        item.p = -1;
      }
    }
  }

  if (process.env.NODE_ENV !== "production") {
    const check = i => {
      return formulaAll[i.name] !== undefined;
    };
    for (let key in formulaAll) {
      for (let i in formulaAll[key]) {
        const item = formulaAll[key][i];
        if (item.s.length > 1 && key != item.s[0].name) {
          console.warn(
            `warning: formula '${key}' first product is '${item.s[0].name}', must is '${key}'.`
          );
        }
        if (!item.s.every(check)) {
          console.warn(
            `warning: formula '${key}-${i}' product does not exist `
          );
        }
        if (!item.q.every(check)) {
          console.warn(
            `warning: formula '${key}-${i}' material does not exist `
          );
        }
        if (factorys[item.m] === undefined) {
          console.warn(
            `warning: formula '${key}-${i}' factory '${item.m}' does not exist `
          );
        }
        if (!item.t) {
          console.warn(
            `warning: formula '${key}-${i}' build time does not exist `
          );
        }
      }
    }
  }
};

export const formulaAll = {
  // 原料
  铁矿: [
    { s: [{ name: "铁矿" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "铁矿" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "铁矿" }], q: [], m: "大型采矿机", t: 1 }
  ],
  铜矿: [
    { s: [{ name: "铜矿" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "铜矿" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "铜矿" }], q: [], m: "大型采矿机", t: 1 }
  ],
  钛石: [
    { s: [{ name: "钛石" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "钛石" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "钛石" }], q: [], m: "大型采矿机", t: 1 }
  ],
  石矿: [
    { s: [{ name: "石矿" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "石矿" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "石矿" }], q: [], m: "大型采矿机", t: 1 }
  ],
  煤矿: [
    { s: [{ name: "煤矿" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "煤矿" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "煤矿" }], q: [], m: "大型采矿机", t: 1 }
  ],
  水: [{ s: [{ name: "水" }], q: [], m: "抽水机", t: 1 }],
  原油: [{ s: [{ name: "原油" }], q: [], m: "原油萃取站", t: 1 }],
  可燃冰: [
    {
      s: [{ name: "可燃冰" }, { name: "氢", n: 0 }],
      group: "组件",
      title: "冰巨星+轨道采集器",
      m: "冰巨采集器",
      mp: "冰巨采集器_可燃冰",
      q: [],
      t: 1,
      p: -1
    },
    { s: [{ name: "可燃冰" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "可燃冰" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "可燃冰" }], q: [], m: "大型采矿机", t: 1 }
  ],
  金伯利矿石: [
    { s: [{ name: "金伯利矿石" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "金伯利矿石" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "金伯利矿石" }], q: [], m: "大型采矿机", t: 1 }
  ],
  分形硅石: [
    { s: [{ name: "分形硅石" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "分形硅石" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "分形硅石" }], q: [], m: "大型采矿机", t: 1 }
  ],
  光栅石: [
    { s: [{ name: "光栅石" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "光栅石" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "光栅石" }], q: [], m: "大型采矿机", t: 1 }
  ],
  刺笋结晶: [
    { s: [{ name: "刺笋结晶" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "刺笋结晶" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "刺笋结晶" }], q: [], m: "大型采矿机", t: 1 }
  ],
  单极磁石: [
    { s: [{ name: "单极磁石" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "单极磁石" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "单极磁石" }], q: [], m: "大型采矿机", t: 1 }
  ],
  临界光子: [
    {
      s: [{ name: "临界光子" }],
      group: "组件",
      m: "射线接收站",
      q: [],
      t: 10,
      p: -1
    },
    {
      s: [{ name: "临界光子", n: 3 }],
      group: "组件",
      title: "射线接收站+引力透镜",
      m: "射线接收站",
      q: [{ name: "引力透镜", n: 0.025 }],
      t: 15,
      p: 1
    }
  ],
  能量碎片: [{ s: [{ name: "能量碎片" }], q: [], m: "黑雾残骸", t: 1 }],
  负熵奇点: [{ s: [{ name: "负熵奇点" }], q: [], m: "黑雾残骸", t: 1 }],
  物质重组器: [{ s: [{ name: "物质重组器" }], q: [], m: "黑雾残骸", t: 1 }],
  硅基神经元: [{ s: [{ name: "硅基神经元" }], q: [], m: "黑雾残骸", t: 1 }],
  黑雾矩阵: [{ s: [{ name: "黑雾矩阵" }], q: [], m: "黑雾残骸", t: 1 }],
  核心素: [{ s: [{ name: "核心素" }], q: [], m: "黑雾残骸", t: 1 }],

  // 组件
  铁块: [
    {
      s: [{ name: "铁块" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "铁矿", n: 1 }],
      t: 1
    }
  ],
  铜块: [
    {
      s: [{ name: "铜块" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "铜矿", n: 1 }],
      t: 1
    }
  ],
  高纯硅块: [
    {
      s: [{ name: "高纯硅块" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "硅石", n: 2 }],
      t: 2
    }
  ],
  钛块: [
    {
      s: [{ name: "钛块" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "钛石", n: 2 }],
      t: 2
    }
  ],
  石材: [
    {
      s: [{ name: "石材" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "石矿", n: 1 }],
      t: 1
    }
  ],
  高级石墨: [
    {
      s: [{ name: "高级石墨" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "煤矿", n: 2 }],
      t: 2,
      p: 1
    },
    {
      s: [{ name: "高级石墨" }, { name: "氢", n: 3, rn: 1 }],
      group: "组件",
      title: "X射线裂解",
      m: "原油精炼厂",
      q: [
        { name: "氢", n: 2, rn: 0 },
        { name: "精炼油", n: 1 }
      ],
      t: 4,
      p: 1
    }
  ],
  精炼油: [
    {
      s: [
        { name: "精炼油", n: 2 },
        { name: "氢", n: 1 }
      ],
      group: "组件",
      title: "等离子精炼",
      m: "原油精炼厂",
      q: [{ name: "原油", n: 2 }],
      t: 4
    },
    {
      s: [{ name: "精炼油", n: 3, rn: 1 }],
      group: "组件",
      title: "重整精炼",
      m: "原油精炼厂",
      q: [
        { name: "精炼油", n: 2, rn: 0 },
        { name: "氢", n: 1 },
        { name: "煤矿", n: 1 }
      ],
      t: 4,
      p: 1
    },
    {
      s: [{ name: "精炼油", n: 3 }],
      group: "组件",
      title: "等离子精炼+重整精炼",
      m: "原油精炼厂",
      q: [
        { name: "原油", n: 2 },
        { name: "煤矿", n: 1 }
      ],
      t: 8,
      p: 1
    }
  ],
  石墨烯: [
    {
      s: [
        { name: "石墨烯", n: 2 },
        { name: "氢", n: 1 }
      ],
      group: "组件",
      m: "化工厂",
      q: [{ name: "可燃冰", n: 2 }],
      t: 2
    },
    {
      s: [{ name: "石墨烯", n: 2 }],
      group: "组件",
      m: "化工厂",
      q: [
        { name: "硫酸", n: 1 },
        { name: "高级石墨", n: 3 }
      ],
      t: 3
    }
  ],
  塑料: [
    {
      s: [{ name: "塑料" }],
      group: "组件",
      m: "化工厂",
      q: [
        { name: "精炼油", n: 2 },
        { name: "高级石墨", n: 1 }
      ],
      t: 3
    }
  ],
  "增产剂Mk.Ⅰ": [
    {
      s: [{ name: "增产剂Mk.Ⅰ" }],
      group: "消耗品",
      m: "制作台",
      q: [{ name: "煤矿", n: 1 }],
      t: 0.5
    }
  ],
  "增产剂Mk.Ⅱ": [
    {
      s: [{ name: "增产剂Mk.Ⅱ" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "增产剂Mk.Ⅰ", n: 2 },
        { name: "金刚石", n: 1 }
      ],
      t: 1
    }
  ],
  "增产剂Mk.Ⅲ": [
    {
      s: [{ name: "增产剂Mk.Ⅲ" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "增产剂Mk.Ⅱ", n: 2 },
        { name: "碳纳米管", n: 1 }
      ],
      t: 2
    }
  ],
  机枪弹箱: [
    {
      s: [{ name: "机枪弹箱" }],
      group: "组件",
      m: "制作台",
      q: [{ name: "铜块", n: 4 }],
      t: 1
    }
  ],
  导弹组: [
    {
      s: [{ name: "导弹组" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "铜块", n: 6 },
        { name: "电路板", n: 3 },
        { name: "燃烧单元", n: 2 },
        { name: "动力引擎", n: 1 }
      ],
      t: 2
    }
  ],

  磁铁: [
    {
      s: [{ name: "磁铁" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "铁矿", n: 1 }],
      t: 1.5
    }
  ],
  磁线圈: [
    {
      s: [{ name: "磁线圈", n: 2 }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "磁铁", n: 2 },
        { name: "铜块", n: 1 }
      ],
      t: 1
    }
  ],
  晶格硅: [
    {
      s: [{ name: "晶格硅" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "高纯硅块", n: 1 }],
      t: 2
    },
    {
      s: [{ name: "晶格硅", n: 2 }],
      group: "组件",
      m: "制作台",
      q: [{ name: "分形硅石", n: 1 }],
      t: 1.5
    }
  ],
  钛合金: [
    {
      s: [{ name: "钛合金", n: 4 }],
      group: "组件",
      m: "冶炼设备",
      q: [
        { name: "钛块", n: 4 },
        { name: "钢材", n: 4 },
        { name: "硫酸", n: 8 }
      ],
      t: 12
    }
  ],
  玻璃: [
    {
      s: [{ name: "玻璃" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "石矿", n: 2 }],
      t: 2
    }
  ],
  金刚石: [
    {
      s: [{ name: "金刚石" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "高级石墨", n: 1 }],
      t: 2
    },
    {
      s: [{ name: "金刚石", n: 2 }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "金伯利矿石", n: 1 }],
      t: 1.5
    }
  ],
  有机晶体: [
    {
      s: [{ name: "有机晶体" }],
      group: "组件",
      m: "化工厂",
      q: [
        { name: "塑料", n: 2 },
        { name: "精炼油", n: 1 },
        { name: "水", n: 1 }
      ],
      t: 6
    },
    { s: [{ name: "有机晶体" }], group: "组件", m: "矿脉", q: [], t: 1 },
    {
      s: [{ name: "有机晶体" }],
      group: "组件",
      m: "采矿机",
      q: [],
      t: 1,
      p: -1
    },
    {
      s: [{ name: "有机晶体" }],
      group: "组件",
      m: "大型采矿机",
      q: [],
      t: 1,
      p: -1
    }
  ],
  燃烧单元: [
    {
      s: [{ name: "燃烧单元" }],
      group: "组件",
      m: "制作台",
      q: [{ name: "煤矿", n: 3 }],
      t: 3
    }
  ],
  爆破单元: [
    {
      s: [{ name: "爆破单元", n: 2 }],
      group: "组件",
      m: "化工厂",
      q: [
        { name: "燃烧单元", n: 2 },
        { name: "塑料", n: 2 },
        { name: "硫酸", n: 1 }
      ],
      t: 6
    }
  ],
  晶石爆破单元: [
    {
      s: [{ name: "晶石爆破单元", n: 8 }],
      group: "组件",
      m: "化工厂",
      q: [
        { name: "爆破单元", n: 8 },
        { name: "卡西米尔晶体", n: 1 },
        { name: "晶格硅", n: 8 }
      ],
      t: 24
    }
  ],
  钛化弹箱: [
    {
      s: [{ name: "钛化弹箱" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "机枪弹箱", n: 1 },
        { name: "钛块", n: 2 }
      ],
      t: 2
    }
  ],
  超音速导弹组: [
    {
      s: [{ name: "超音速导弹组", n: 2 }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "导弹组", n: 2 },
        { name: "处理器", n: 4 },
        { name: "爆破单元", n: 4 },
        { name: "推进器", n: 2 }
      ],
      t: 4
    }
  ],

  钢材: [
    {
      s: [{ name: "钢材" }],
      group: "组件",
      m: "冶炼设备",
      q: [{ name: "铁块", n: 3 }],
      t: 3
    }
  ],
  电动机: [
    {
      s: [{ name: "电动机" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "铁块", n: 2 },
        { name: "齿轮", n: 1 },
        { name: "磁线圈", n: 1 }
      ],
      t: 2
    }
  ],
  钛化玻璃: [
    {
      s: [{ name: "钛化玻璃", n: 2 }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "玻璃", n: 2 },
        { name: "钛块", n: 2 },
        { name: "水", n: 2 }
      ],
      t: 5
    }
  ],
  棱镜: [
    {
      s: [{ name: "棱镜", n: 2 }],
      group: "组件",
      m: "制作台",
      q: [{ name: "玻璃", n: 3 }],
      t: 2
    }
  ],
  钛晶石: [
    {
      s: [{ name: "钛晶石" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "有机晶体", n: 1 },
        { name: "钛块", n: 3 }
      ],
      t: 4
    }
  ],
  动力引擎: [
    {
      s: [{ name: "动力引擎" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "磁线圈", n: 1 },
        { name: "铜块", n: 2 }
      ],
      t: 3
    }
  ],
  推进器: [
    {
      s: [{ name: "推进器" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 2 },
        { name: "铜块", n: 3 }
      ],
      t: 4
    }
  ],
  加力推进器: [
    {
      s: [{ name: "加力推进器" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钛合金", n: 5 },
        { name: "电磁涡轮", n: 5 }
      ],
      t: 6
    }
  ],
  超合金弹箱: [
    {
      s: [{ name: "超合金弹箱" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "钛化弹箱", n: 1 },
        { name: "钛合金", n: 2 }
      ],
      t: 3
    }
  ],
  引力导弹组: [
    {
      s: [{ name: "引力导弹组", n: 3 }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "超音速导弹组", n: 3 },
        { name: "晶石爆破单元", n: 6 },
        { name: "奇异物质", n: 3 }
      ],
      t: 6
    }
  ],

  齿轮: [
    {
      s: [{ name: "齿轮" }],
      group: "组件",
      m: "制作台",
      q: [{ name: "铁块", n: 1 }],
      t: 1
    }
  ],
  电磁涡轮: [
    {
      s: [{ name: "电磁涡轮" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "电动机", n: 2 },
        { name: "磁线圈", n: 2 }
      ],
      t: 2
    }
  ],
  硅石: [
    { s: [{ name: "硅石" }], q: [], m: "矿脉", t: 1 },
    { s: [{ name: "硅石" }], q: [], m: "采矿机", t: 1 },
    { s: [{ name: "硅石" }], q: [], m: "大型采矿机", t: 1 },
    {
      s: [{ name: "硅石" }],
      q: [{ name: "石矿", n: 10 }],
      m: "冶炼设备",
      t: 10
    }
  ],
  电路板: [
    {
      s: [{ name: "电路板", n: 2 }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "铁块", n: 2 },
        { name: "铜块", n: 1 }
      ],
      t: 1
    }
  ],
  引力透镜: [
    {
      s: [{ name: "引力透镜" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "金刚石", n: 4 },
        { name: "奇异物质", n: 1 }
      ],
      t: 6
    }
  ],
  硫酸: [
    {
      s: [{ name: "硫酸", n: 4 }],
      group: "组件",
      m: "化工厂",
      q: [
        { name: "精炼油", n: 6 },
        { name: "石矿", n: 8 },
        { name: "水", n: 4 }
      ],
      t: 6
    },
    {
      s: [{ name: "硫酸" }],
      group: "组件",
      m: "抽水机",
      q: [],
      t: 1
    }
  ],
  氢: [
    {
      s: [{ name: "氢" }, { name: "重氢", n: 0 }],
      group: "组件",
      title: "气态巨星+轨道采集器",
      m: "气巨采集器",
      mp: "气巨采集器_氢",
      q: [],
      t: 1,
      p: -1
    },
    {
      s: [{ name: "氢" }, { name: "可燃冰", n: 0 }],
      group: "组件",
      title: "冰巨星+轨道采集器",
      m: "冰巨采集器",
      mp: "冰巨采集器_氢",
      q: [],
      t: 1,
      p: -1
    },
    {
      s: [{ name: "氢" }, { name: "精炼油", n: 2 }],
      group: "组件",
      title: "等离子精炼",
      m: "原油精炼厂",
      q: [{ name: "原油", n: 2 }],
      t: 4
    },
    {
      s: [
        { name: "氢", n: 3, rn: 1 },
        { name: "高级石墨", n: 1 }
      ],
      group: "组件",
      title: "X射线裂解",
      m: "原油精炼厂",
      q: [
        { name: "氢", n: 2, rn: 0 },
        { name: "精炼油", n: 1 }
      ],
      t: 4,
      chanliang: 3,
      p: 1
    },
    {
      s: [{ name: "氢" }, { name: "石墨烯", n: 2 }],
      group: "组件",
      m: "化工厂",
      q: [{ name: "可燃冰", n: 2 }],
      t: 2
    },
    {
      s: [
        { name: "氢", n: 2 },
        { name: "反物质", n: 2 }
      ],
      group: "组件",
      title: "质能存储",
      m: "微型粒子对撞机",
      q: [{ name: "临界光子", n: 2 }],
      t: 2,
      p: 1
    }
  ],
  碳纳米管: [
    {
      s: [{ name: "碳纳米管", n: 2 }],
      group: "组件",
      m: "化工厂",
      q: [
        { name: "石墨烯", n: 3 },
        { name: "钛块", n: 1 }
      ],
      t: 4
    },
    {
      s: [{ name: "碳纳米管", n: 2 }],
      group: "组件",
      m: "化工厂",
      q: [{ name: "刺笋结晶", n: 6 }],
      t: 4
    }
  ],
  奇异物质: [
    {
      s: [{ name: "奇异物质" }],
      group: "组件",
      m: "微型粒子对撞机",
      q: [
        { name: "粒子容器", n: 2 },
        { name: "铁块", n: 2 },
        { name: "重氢", n: 10 }
      ],
      t: 8
    }
  ],
  配送运输机: [
    {
      s: [{ name: "配送运输机" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "铁块", n: 2 },
        { name: "动力引擎", n: 1 },
        { name: "处理器", n: 1 }
      ],
      t: 2
    }
  ],
  物流运输机: [
    {
      s: [{ name: "物流运输机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 5 },
        { name: "处理器", n: 2 },
        { name: "推进器", n: 2 }
      ],
      t: 4
    }
  ],
  星际物流运输机: [
    {
      s: [{ name: "星际物流运输机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钛合金", n: 10 },
        { name: "处理器", n: 10 },
        { name: "加力推进器", n: 2 }
      ],
      t: 6
    }
  ],
  等离子胶囊: [
    {
      s: [{ name: "等离子胶囊" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "石墨烯", n: 1 },
        { name: "磁铁", n: 2 },
        { name: "重氢", n: 10 }
      ],
      t: 2
    }
  ],
  炮弹组: [
    {
      s: [{ name: "炮弹组" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "铜块", n: 9 },
        { name: "燃烧单元", n: 2 }
      ],
      t: 1.5
    }
  ],

  电浆激发器: [
    {
      s: [{ name: "电浆激发器" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "磁线圈", n: 4 },
        { name: "棱镜", n: 2 }
      ],
      t: 2
    }
  ],
  超级磁场环: [
    {
      s: [{ name: "超级磁场环" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "电磁涡轮", n: 2 },
        { name: "磁铁", n: 3 },
        { name: "高级石墨", n: 1 }
      ],
      t: 3
    }
  ],
  粒子带宽: [
    {
      s: [{ name: "粒子带宽" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "碳纳米管", n: 2 },
        { name: "晶格硅", n: 2 },
        { name: "塑料", n: 1 }
      ],
      t: 8
    }
  ],
  处理器: [
    {
      s: [{ name: "处理器" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "电路板", n: 2 },
        { name: "微晶元件", n: 2 }
      ],
      t: 3
    }
  ],
  卡西米尔晶体: [
    {
      s: [{ name: "卡西米尔晶体" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "钛晶石", n: 1 },
        { name: "石墨烯", n: 2 },
        { name: "氢", n: 12 }
      ],
      t: 4
    },
    {
      s: [{ name: "卡西米尔晶体" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "光栅石", n: 8 },
        { name: "石墨烯", n: 2 },
        { name: "氢", n: 12 }
      ],
      t: 4
    }
  ],
  粒子容器: [
    {
      s: [{ name: "粒子容器" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "电磁涡轮", n: 2 },
        { name: "铜块", n: 2 },
        { name: "石墨烯", n: 2 }
      ],
      t: 4
    },
    {
      s: [{ name: "粒子容器" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "单极磁石", n: 10 },
        { name: "铜块", n: 2 }
      ],
      t: 4
    }
  ],
  重氢: [
    {
      s: [{ name: "重氢" }, { name: "氢", n: 0 }],
      group: "组件",
      title: "体态巨星+轨道采集器",
      m: "气巨采集器",
      mp: "气巨采集器_重氢",
      q: [],
      t: 1,
      p: -1
    },
    {
      s: [{ name: "重氢", n: 5 }],
      group: "组件",
      m: "微型粒子对撞机",
      q: [{ name: "氢", n: 10 }],
      t: 2.5,
      p: 1
    },
    {
      s: [
        { name: "重氢", n: 0.01 },
        { name: "氢", n: 0.99, rn: 0.0 }
      ],
      group: "组件",
      title: "重氢分馏",
      m: "分馏塔",
      q: [{ name: "氢", n: 1, rn: 0.01 }],
      t: 1,
      p: 1
    }
  ],
  太阳帆: [
    {
      s: [{ name: "太阳帆", n: 2 }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "石墨烯", n: 1 },
        { name: "光子合并器", n: 1 }
      ],
      t: 4
    }
  ],
  框架材料: [
    {
      s: [{ name: "框架材料" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "碳纳米管", n: 4 },
        { name: "钛合金", n: 1 },
        { name: "高纯硅块", n: 1 }
      ],
      t: 6
    }
  ],
  戴森球组件: [
    {
      s: [{ name: "戴森球组件" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "框架材料", n: 3 },
        { name: "太阳帆", n: 3 },
        { name: "处理器", n: 3 }
      ],
      t: 8
    }
  ],
  小型运载火箭: [
    {
      s: [{ name: "小型运载火箭" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "戴森球组件", n: 2 },
        { name: "氘核燃料棒", n: 4 },
        { name: "量子芯片", n: 2 }
      ],
      t: 6
    }
  ],
  反物质胶囊: [
    {
      s: [{ name: "反物质胶囊" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "等离子胶囊", n: 1 },
        { name: "粒子容器", n: 1 },
        { name: "氢", n: 10 },
        { name: "反物质", n: 10 }
      ],
      t: 2
    }
  ],
  高爆炮弹组: [
    {
      s: [{ name: "高爆炮弹组" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "炮弹组", n: 1 },
        { name: "钛块", n: 6 },
        { name: "爆破单元", n: 2 }
      ],
      t: 6
    }
  ],

  光子合并器: [
    {
      s: [{ name: "光子合并器" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "棱镜", n: 2 },
        { name: "电路板", n: 1 }
      ],
      t: 3
    },
    {
      s: [{ name: "光子合并器" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "光栅石", n: 1 },
        { name: "电路板", n: 1 }
      ],
      t: 3
    }
  ],
  微晶元件: [
    {
      s: [{ name: "微晶元件" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "高纯硅块", n: 2 },
        { name: "铜块", n: 1 }
      ],
      t: 2
    }
  ],
  量子芯片: [
    {
      s: [{ name: "量子芯片" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "处理器", n: 2 },
        { name: "位面过滤器", n: 2 }
      ],
      t: 6
    }
  ],
  液氢燃料棒: [
    {
      s: [{ name: "液氢燃料棒", n: 2 }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "钛块", n: 1 },
        { name: "氢", n: 10 }
      ],
      t: 6
    }
  ],
  氘核燃料棒: [
    {
      s: [{ name: "氘核燃料棒", n: 2 }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "钛合金", n: 1 },
        { name: "重氢", n: 20 },
        { name: "超级磁场环", n: 1 }
      ],
      t: 12
    }
  ],
  反物质燃料棒: [
    {
      s: [{ name: "反物质燃料棒", n: 2 }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "反物质", n: 12 },
        { name: "氢", n: 12 },
        { name: "湮灭约束球", n: 1 },
        { name: "钛合金", n: 1 }
      ],
      t: 24,
      p: 1
    }
  ],
  奇异湮灭燃料棒: [
    {
      s: [{ name: "奇异湮灭燃料棒" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "反物质燃料棒", n: 8 },
        { name: "核心素", n: 1 },
        { name: "奇异物质", n: 2 },
        { name: "框架材料", n: 1 }
      ],
      t: 32,
      p: 1
    }
  ],
  干扰胶囊: [
    {
      s: [{ name: "干扰胶囊" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "电磁涡轮", n: 1 },
        { name: "电浆激发器", n: 1 },
        { name: "氢", n: 3 }
      ],
      t: 2
    }
  ],
  压制胶囊: [
    {
      s: [{ name: "压制胶囊" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "干扰胶囊", n: 1 },
        { name: "超级磁场环", n: 2 },
        { name: "钛化玻璃", n: 1 }
      ],
      t: 8
    }
  ],
  位面过滤器: [
    {
      s: [{ name: "位面过滤器" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "卡西米尔晶体", n: 1 },
        { name: "钛化玻璃", n: 2 }
      ],
      t: 12
    }
  ],
  反物质: [
    {
      s: [
        { name: "反物质", n: 2 },
        { name: "氢", n: 2 }
      ],
      group: "组件",
      title: "质能存储",
      m: "微型粒子对撞机",
      q: [{ name: "临界光子", n: 2 }],
      t: 2
    }
  ],
  湮灭约束球: [
    {
      s: [{ name: "湮灭约束球" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "粒子容器", n: 1 },
        { name: "处理器", n: 1 }
      ],
      t: 20
    }
  ],
  晶石炮弹组: [
    {
      s: [{ name: "晶石炮弹组" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "高爆炮弹组", n: 1 },
        { name: "钛合金", n: 3 },
        { name: "晶石爆破单元", n: 2 }
      ],
      t: 6
    }
  ],

  电磁矩阵: [
    {
      s: [{ name: "电磁矩阵" }],
      q: [
        { name: "磁线圈", n: 1 },
        { name: "电路板", n: 1 }
      ],
      t: 3,
      m: "矩阵研究站",
      group: "产品"
    }
  ],
  能量矩阵: [
    {
      s: [{ name: "能量矩阵" }],
      q: [
        { name: "高级石墨", n: 2 },
        { name: "氢", n: 2 }
      ],
      t: 6,
      m: "矩阵研究站",
      group: "产品"
    }
  ],
  结构矩阵: [
    {
      s: [{ name: "结构矩阵" }],
      q: [
        { name: "金刚石", n: 1 },
        { name: "钛晶石", n: 1 }
      ],
      t: 8,
      m: "矩阵研究站",
      group: "产品"
    }
  ],
  信息矩阵: [
    {
      s: [{ name: "信息矩阵" }],
      q: [
        { name: "处理器", n: 2 },
        { name: "粒子带宽", n: 1 }
      ],
      t: 10,
      m: "矩阵研究站",
      group: "产品"
    }
  ],
  引力矩阵: [
    {
      s: [{ name: "引力矩阵", n: 2 }],
      q: [
        { name: "量子芯片", n: 1 },
        { name: "引力透镜", n: 1 }
      ],
      t: 24,
      m: "矩阵研究站",
      group: "产品"
    }
  ],
  宇宙矩阵: [
    {
      s: [{ name: "宇宙矩阵" }],
      q: [
        { name: "电磁矩阵", n: 1 },
        { name: "能量矩阵", n: 1 },
        { name: "结构矩阵", n: 1 },
        { name: "信息矩阵", n: 1 },
        { name: "引力矩阵", n: 1 },
        { name: "反物质", n: 1 }
      ],
      t: 15,
      m: "矩阵研究站",
      group: "产品"
    }
  ],
  原型机: [
    {
      s: [{ name: "原型机" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "铁块", n: 3 },
        { name: "动力引擎", n: 1 },
        { name: "电路板", n: 2 },
        { name: "电浆激发器", n: 1 }
      ],
      t: 2
    }
  ],
  精准无人机: [
    {
      s: [{ name: "精准无人机" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "原型机", n: 1 },
        { name: "电磁涡轮", n: 1 },
        { name: "电路板", n: 2 },
        { name: "光子合并器", n: 2 }
      ],
      t: 4
    }
  ],
  攻击无人机: [
    {
      s: [{ name: "攻击无人机" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "原型机", n: 1 },
        { name: "电磁涡轮", n: 1 },
        { name: "处理器", n: 1 },
        { name: "粒子容器", n: 1 }
      ],
      t: 4
    }
  ],
  护卫舰: [
    {
      s: [{ name: "护卫舰" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "钛合金", n: 5 },
        { name: "加力推进器", n: 1 },
        { name: "处理器", n: 2 },
        { name: "粒子容器", n: 3 }
      ],
      t: 5
    }
  ],
  驱逐舰: [
    {
      s: [{ name: "驱逐舰" }],
      group: "消耗品",
      m: "制作台",
      q: [
        { name: "框架材料", n: 20 },
        { name: "加力推进器", n: 4 },
        { name: "处理器", n: 4 },
        { name: "奇异物质", n: 1 }
      ],
      t: 8
    }
  ],
  空间翘曲器: [
    {
      s: [{ name: "空间翘曲器", n: 8 }],
      group: "消耗品",
      m: "制作台",
      q: [{ name: "引力矩阵", n: 1 }],
      t: 10
    },
    {
      s: [{ name: "空间翘曲器" }],
      group: "消耗品",
      m: "制作台",
      q: [{ name: "引力透镜", n: 1 }],
      t: 10
    }
  ],
  地基: [
    {
      s: [{ name: "地基" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "石材", n: 3 },
        { name: "钢材", n: 1 }
      ],
      t: 1
    }
  ],

  // 建筑
  电力感应塔: [
    {
      s: [{ name: "电力感应塔" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 2 },
        { name: "磁线圈", n: 1 }
      ],
      t: 1
    }
  ],
  无线输电塔: [
    {
      s: [{ name: "无线输电塔" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "电力感应塔", n: 1 },
        { name: "电浆激发器", n: 3 }
      ],
      t: 3,
      p: 1
    }
  ],
  卫星配电站: [
    {
      s: [{ name: "卫星配电站" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "无线输电塔", n: 1 },
        { name: "超级磁场环", n: 10 },
        { name: "框架材料", n: 2 }
      ],
      t: 5,
      p: 1
    }
  ],
  风力涡轮机: [
    {
      s: [{ name: "风力涡轮机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 6 },
        { name: "齿轮", n: 1 },
        { name: "磁线圈", n: 3 }
      ],
      t: 4
    }
  ],
  火力发电机: [
    {
      s: [{ name: "火力发电机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 10 },
        { name: "石材", n: 4 },
        { name: "齿轮", n: 4 },
        { name: "磁线圈", n: 4 }
      ],
      t: 5
    }
  ],
  太阳能板: [
    {
      s: [{ name: "太阳能板" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "高纯硅块", n: 10 },
        { name: "铜块", n: 10 },
        { name: "电路板", n: 5 }
      ],
      t: 6
    }
  ],
  蓄电池: [
    {
      s: [{ name: "蓄电池" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 6 },
        { name: "超级磁场环", n: 1 },
        { name: "晶格硅", n: 3 }
      ],
      t: 3
    }
  ],
  蓄电池满: [
    {
      s: [{ name: "蓄电池满" }],
      group: "建筑",
      m: "能量枢纽",
      q: [{ name: "蓄电池", n: 1 }],
      t: 10,
      p: 1
    }
  ],
  地热发电站: [
    {
      s: [{ name: "地热发电站" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 15 },
        { name: "铜块", n: 20 },
        { name: "光子合并器", n: 4 },
        { name: "超级磁场环", n: 1 }
      ],
      t: 6
    }
  ],
  微型聚变发电站: [
    {
      s: [{ name: "微型聚变发电站" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钛合金", n: 12 },
        { name: "超级磁场环", n: 10 },
        { name: "碳纳米管", n: 8 },
        { name: "处理器", n: 4 }
      ],
      t: 10
    }
  ],
  能量枢纽: [
    {
      s: [{ name: "能量枢纽" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 40 },
        { name: "钛合金", n: 40 },
        { name: "处理器", n: 40 },
        { name: "粒子容器", n: 8 }
      ],
      t: 15
    }
  ],
  射线接收站: [
    {
      s: [{ name: "射线接收站" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 20 },
        { name: "高纯硅块", n: 20 },
        { name: "光子合并器", n: 10 },
        { name: "处理器", n: 5 },
        { name: "超级磁场环", n: 20 }
      ],
      t: 8
    }
  ],
  人造恒星: [
    {
      s: [{ name: "人造恒星" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钛合金", n: 20 },
        { name: "框架材料", n: 20 },
        { name: "湮灭约束球", n: 10 },
        { name: "量子芯片", n: 10 }
      ],
      t: 30
    }
  ],

  传送带: [
    {
      s: [{ name: "传送带", n: 3 }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 2 },
        { name: "齿轮", n: 1 }
      ],
      t: 1
    }
  ],
  高速传送带: [
    {
      s: [{ name: "高速传送带", n: 3 }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "传送带", n: 3 },
        { name: "电磁涡轮", n: 1 }
      ],
      t: 1,
      p: 1
    }
  ],
  极速传送带: [
    {
      s: [{ name: "极速传送带", n: 3 }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "高速传送带", n: 3 },
        { name: "超级磁场环", n: 1 },
        { name: "石墨烯", n: 1 }
      ],
      t: 1,
      p: 1
    }
  ],
  四向分流器: [
    {
      s: [{ name: "四向分流器" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "铁块", n: 3 },
        { name: "齿轮", n: 2 },
        { name: "电路板", n: 1 }
      ],
      t: 2
    }
  ],
  自动集装机: [
    {
      s: [{ name: "自动集装机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 3 },
        { name: "齿轮", n: 4 },
        { name: "超级磁场环", n: 1 },
        { name: "处理器", n: 2 }
      ],
      t: 4
    }
  ],
  流速监测器: [
    {
      s: [{ name: "流速监测器" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 3 },
        { name: "齿轮", n: 2 },
        { name: "玻璃", n: 1 },
        { name: "电路板", n: 2 }
      ],
      t: 2
    }
  ],
  喷涂机: [
    {
      s: [{ name: "喷涂机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 4 },
        { name: "电浆激发器", n: 2 },
        { name: "电路板", n: 2 },
        { name: "微晶元件", n: 2 }
      ],
      t: 3
    }
  ],
  小型储物仓: [
    {
      s: [{ name: "小型储物仓" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "铁块", n: 4 },
        { name: "石材", n: 4 }
      ],
      t: 2
    }
  ],
  大型储物仓: [
    {
      s: [{ name: "大型储物仓" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "钢材", n: 8 },
        { name: "石材", n: 8 }
      ],
      t: 4
    }
  ],
  储液灌: [
    {
      s: [{ name: "储液灌" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 8 },
        { name: "石材", n: 4 },
        { name: "玻璃", n: 4 }
      ],
      t: 2
    }
  ],
  物流配送器: [
    {
      s: [{ name: "物流配送器" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 8 },
        { name: "电浆激发器", n: 4 },
        { name: "处理器", n: 4 }
      ],
      t: 8
    }
  ],
  行星内物流运输站: [
    {
      s: [{ name: "行星内物流运输站" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 40 },
        { name: "钛块", n: 40 },
        { name: "处理器", n: 40 },
        { name: "粒子容器", n: 20 }
      ],
      t: 20
    }
  ],
  星际物流运输站: [
    {
      s: [{ name: "星际物流运输站" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "行星内物流运输站", n: 1 },
        { name: "钛合金", n: 40 },
        { name: "粒子容器", n: 20 }
      ],
      t: 30,
      p: 1
    }
  ],
  轨道采集器: [
    {
      s: [{ name: "轨道采集器" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "星际物流运输站", n: 1 },
        { name: "超级磁场环", n: 50 },
        { name: "加力推进器", n: 20 },
        { name: "蓄电池满", n: 20 }
      ],
      t: 30,
      p: 1
    }
  ],

  分拣器: [
    {
      s: [{ name: "分拣器" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "铁块", n: 1 },
        { name: "电路板", n: 1 }
      ],
      t: 1
    }
  ],
  高速分拣器: [
    {
      s: [{ name: "高速分拣器", n: 2 }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "分拣器", n: 2 },
        { name: "电动机", n: 1 }
      ],
      t: 1,
      p: 1
    }
  ],
  极速分拣器: [
    {
      s: [{ name: "极速分拣器", n: 2 }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "高速分拣器", n: 2 },
        { name: "电磁涡轮", n: 1 }
      ],
      t: 1,
      p: 1
    }
  ],
  集装分拣器: [
    {
      s: [{ name: "集装分拣器", n: 1 }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "极速分拣器", n: 2 },
        { name: "超级磁场环", n: 1 },
        { name: "处理器", n: 1 }
      ],
      t: 1,
      p: 1
    }
  ],
  采矿机: [
    {
      s: [{ name: "采矿机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 4 },
        { name: "电路板", n: 2 },
        { name: "磁线圈", n: 2 },
        { name: "齿轮", n: 2 }
      ],
      t: 3
    }
  ],
  大型采矿机: [
    {
      s: [{ name: "大型采矿机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钛合金", n: 20 },
        { name: "框架材料", n: 10 },
        { name: "超级磁场环", n: 10 },
        { name: "量子芯片", n: 4 },
        { name: "光栅石", n: 40 }
      ],
      t: 20
    }
  ],
  抽水机: [
    {
      s: [{ name: "抽水机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 8 },
        { name: "石材", n: 4 },
        { name: "电动机", n: 4 },
        { name: "电路板", n: 2 }
      ],
      t: 4
    }
  ],
  原油萃取站: [
    {
      s: [{ name: "原油萃取站" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "钢材", n: 12 },
        { name: "石材", n: 12 },
        { name: "电路板", n: 6 },
        { name: "电浆激发器", n: 4 }
      ],
      t: 8
    }
  ],
  原油精炼厂: [
    {
      s: [{ name: "原油精炼厂" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "钢材", n: 10 },
        { name: "石材", n: 10 },
        { name: "电路板", n: 6 },
        { name: "电浆激发器", n: 6 }
      ],
      t: 6
    }
  ],
  分馏塔: [
    {
      s: [{ name: "分馏塔" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 8 },
        { name: "石材", n: 4 },
        { name: "玻璃", n: 4 },
        { name: "处理器", n: 1 }
      ],
      t: 3
    }
  ],
  化工厂: [
    {
      s: [{ name: "化工厂" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 8 },
        { name: "石材", n: 8 },
        { name: "玻璃", n: 8 },
        { name: "电路板", n: 2 }
      ],
      t: 5
    }
  ],
  量子化工厂: [
    {
      s: [{ name: "量子化工厂" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "化工厂", n: 1 },
        { name: "钛化玻璃", n: 10 },
        { name: "奇异物质", n: 3 },
        { name: "量子芯片", n: 3 }
      ],
      t: 10,
      p: 1
    }
  ],
  微型粒子对撞机: [
    {
      s: [{ name: "微型粒子对撞机" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钛合金", n: 20 },
        { name: "框架材料", n: 20 },
        { name: "超级磁场环", n: 25 },
        { name: "石墨烯", n: 10 },
        { name: "处理器", n: 8 }
      ],
      t: 15
    }
  ],

  电弧熔炉: [
    {
      s: [{ name: "电弧熔炉" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 4 },
        { name: "石材", n: 2 },
        { name: "电路板", n: 4 },
        { name: "磁线圈", n: 2 }
      ],
      t: 3
    }
  ],
  位面熔炉: [
    {
      s: [{ name: "位面熔炉" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "电弧熔炉", n: 1 },
        { name: "框架材料", n: 5 },
        { name: "位面过滤器", n: 4 },
        { name: "单极磁石", n: 15 }
      ],
      t: 5,
      p: 1
    }
  ],
  负熵熔炉: [
    {
      s: [{ name: "负熵熔炉" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "位面熔炉", n: 1 },
        { name: "负熵奇点", n: 10 },
        { name: "能量碎片", n: 30 },
        { name: "量子芯片", n: 4 }
      ],
      t: 6,
      p: 1
    }
  ],
  "制作台Mk.Ⅰ": [
    {
      s: [{ name: "制作台Mk.Ⅰ" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 4 },
        { name: "齿轮", n: 8 },
        { name: "电路板", n: 4 }
      ],
      t: 2
    }
  ],
  "制作台Mk.Ⅱ": [
    {
      s: [{ name: "制作台Mk.Ⅱ" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "制作台Mk.Ⅰ", n: 1 },
        { name: "石墨烯", n: 8 },
        { name: "处理器", n: 4 }
      ],
      t: 3,
      p: 1
    }
  ],
  "制作台Mk.Ⅲ": [
    {
      s: [{ name: "制作台Mk.Ⅲ" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "制作台Mk.Ⅱ", n: 1 },
        { name: "粒子带宽", n: 8 },
        { name: "量子芯片", n: 2 }
      ],
      t: 4,
      p: 1
    }
  ],
  重组式制作台: [
    {
      s: [{ name: "重组式制作台" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "制作台Mk.Ⅲ", n: 1 },
        { name: "物质重组器", n: 10 },
        { name: "能量碎片", n: 30 },
        { name: "量子芯片", n: 4 }
      ],
      t: 5,
      p: 1
    }
  ],
  矩阵研究站: [
    {
      s: [{ name: "矩阵研究站" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 8 },
        { name: "玻璃", n: 4 },
        { name: "电路板", n: 4 },
        { name: "磁线圈", n: 4 }
      ],
      t: 3
    }
  ],
  自演化研究站: [
    {
      s: [{ name: "自演化研究站" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "矩阵研究站", n: 1 },
        { name: "硅基神经元", n: 10 },
        { name: "黑雾矩阵", n: 20 },
        { name: "量子芯片", n: 4 }
      ],
      t: 4,
      p: 1
    }
  ],
  电磁轨道弹射器: [
    {
      s: [{ name: "电磁轨道弹射器" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 20 },
        { name: "齿轮", n: 20 },
        { name: "处理器", n: 5 },
        { name: "超级磁场环", n: 10 }
      ],
      t: 6
    }
  ],
  垂直发射井: [
    {
      s: [{ name: "垂直发射井" }],
      group: "组件",
      m: "制作台",
      q: [
        { name: "钛合金", n: 80 },
        { name: "框架材料", n: 30 },
        { name: "引力透镜", n: 20 },
        { name: "量子芯片", n: 10 }
      ],
      t: 30
    }
  ],

  高斯机枪塔: [
    {
      s: [{ name: "高斯机枪塔" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铁块", n: 8 },
        { name: "齿轮", n: 8 },
        { name: "电路板", n: 2 },
        { name: "磁线圈", n: 4 }
      ],
      t: 4
    }
  ],
  导弹防御塔: [
    {
      s: [{ name: "导弹防御塔" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 8 },
        { name: "电动机", n: 6 },
        { name: "电路板", n: 12 },
        { name: "动力引擎", n: 6 }
      ],
      t: 6
    }
  ],
  聚爆加农炮: [
    {
      s: [{ name: "聚爆加农炮" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 10 },
        { name: "电动机", n: 8 },
        { name: "电路板", n: 10 },
        { name: "超级磁场环", n: 2 }
      ],
      t: 5
    }
  ],
  高频激光塔: [
    {
      s: [{ name: "高频激光塔" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 9 },
        { name: "电浆激发器", n: 6 },
        { name: "电路板", n: 6 },
        { name: "光子合并器", n: 9 }
      ],
      t: 6
    }
  ],
  磁化电浆炮: [
    {
      s: [{ name: "磁化电浆炮" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钛合金", n: 20 },
        { name: "钛化玻璃", n: 10 },
        { name: "超级磁场环", n: 10 },
        { name: "电浆激发器", n: 5 },
        { name: "处理器", n: 5 }
      ],
      t: 10
    }
  ],
  近程电浆塔: [
    {
      s: [{ name: "近程电浆塔" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 15 },
        { name: "超级磁场环", n: 5 },
        { name: "电浆激发器", n: 5 },
        { name: "处理器", n: 5 }
      ],
      t: 8
    }
  ],
  战场分析基站: [
    {
      s: [{ name: "战场分析基站" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 12 },
        { name: "电路板", n: 18 },
        { name: "微晶元件", n: 6 },
        { name: "动力引擎", n: 12 }
      ],
      t: 6
    }
  ],
  干扰塔: [
    {
      s: [{ name: "干扰塔" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "铜块", n: 12 },
        { name: "电浆激发器", n: 9 },
        { name: "金刚石", n: 6 },
        { name: "处理器", n: 3 }
      ],
      t: 5
    }
  ],
  信号塔: [
    {
      s: [{ name: "信号塔" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "无线输电塔", n: 2 },
        { name: "钢材", n: 12 },
        { name: "晶格硅", n: 6 }
      ],
      t: 6,
      p: 1
    }
  ],
  行星护盾发生器: [
    {
      s: [{ name: "行星护盾发生器" }],
      group: "建筑",
      m: "制作台",
      q: [
        { name: "钢材", n: 20 },
        { name: "电磁涡轮", n: 20 },
        { name: "超级磁场环", n: 5 },
        { name: "粒子容器", n: 5 }
      ],
      t: 10
    }
  ]
};
